/* EasyHemo Rescue V4.6 — accessible, lightweight floral comparison.
   No purchase/checkout code is touched. */
(() => {
  'use strict';
  const init = (scope = document) => {
    const stages = scope.querySelectorAll('[data-ehs4-compare]');
    stages.forEach((stage) => {
      if (stage.dataset.ehs4Ready === 'true') return;
      const input = stage.querySelector('[data-ehs4-range]');
      if (!input) return;
      stage.dataset.ehs4Ready = 'true';
      const root = stage.closest('.ehs4-compare-card');
      const sync = () => {
        const value = Math.max(0, Math.min(100, Number(input.value) || 0));
        stage.style.setProperty('--ehs4-position', `${value}%`);
      };
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      if (root) {
        root.querySelectorAll('[data-ehs4-show]').forEach((button) => {
          button.addEventListener('click', () => {
            input.value = button.dataset.ehs4Show;
            sync();
          });
        });
      }
      sync();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
